import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { searchComboOpen } from '../SortAndPagination.css';
import { SortByOptionsGroup, SortByOption, SortBySelect, SortBySelected } from './styled';

class SortBySelector extends Component {
  constructor(props) {
    super(props);
    this.state = { open: false };
  }

  render() {
    const { open } = this.state;
    const { onSelect, options, sortFilterSelect, s3BasePath } = this.props;
    const selected = options.find ? options.find(el => el.value === sortFilterSelect) : '';

    return (
      <div style={{ position: 'relative' }}>
        <SortBySelect onClick={() => this.setState({ open: !this.state.open })} data-cy="select-sort-products">
          <SortBySelected data-cy="span-sort-selected">{selected.label}</SortBySelected>
          <div style={searchComboOpen(s3BasePath)} />
        </SortBySelect>
        {open ? (
          <SortByOptionsGroup>
            {options.map((option, index) => (
              <SortByOption
                key={`sort_by_key_${index}`}
                selected={selected.value === option.value}
                data-cy="option-sort-select"
                data-cy-option={option.value}
                onClick={() => {
                  this.setState({ open: !this.state.open });
                  onSelect(option);
                }}
              >
                {option.label}
              </SortByOption>
            ))}
          </SortByOptionsGroup>
        ) : null}
      </div>
    );
  }
}

SortBySelector.propTypes = {
  onSelect: PropTypes.func.isRequired,
  options: PropTypes.array,
  s3BasePath: PropTypes.string,
  sortFilterSelect: PropTypes.string
};

export default SortBySelector;
